















































































import {
  Component,
  Prop,
  PropSync,
  Vue,
  Watch,
  Ref,
} from 'vue-property-decorator';
import PopupCard from './PopupCard.vue';
import DraggableEventTimed from './DraggableEventTimed.vue';
//@ts-ignore
import { shiftDataStore } from '@/store/theoryApiStore/shiftDataModule.ts';

@Component({
  components: {
    PopupCard,
    DraggableEventTimed,
  },
})
export default class WeeklyCalendar extends Vue {
  private eventSummaryFormat(event: any): string {
    return `${event.start.getHours()}:${`00${event.start.getMinutes()}`.slice(
      -2
    )} - ${event.end.getHours()}:${`00${event.end.getMinutes()}`.slice(-2)}, ${
      event.name
    }`;
  }
  private eventSummaryFormatForDraggingOverRay(
    start: Date,
    end: Date,
    name: string
  ): string {
    return `${start.getHours()}:${`00${start.getMinutes()}`.slice(
      -2
    )} - ${end.getHours()}:${`00${end.getMinutes()}`.slice(-2)}, ${name}`;
  }
  @PropSync('focusValue', { type: String, required: true })
  public focus!: string;
  public type: string = 'week';
  public typeToLabel: { [key: string]: string } = {
    month: 'Month',
    week: 'Week',
    day: 'Day',
    '4day': '4 Days',
  };

  private readonly roundTo: number = 15;

  public selectedEventId?: string;
  public selectedElement?: HTMLElement;
  public selectedOpen: boolean = false;

  public createdEventId?: string;

  public isEventCreating: boolean = false;

  private isMouseDownNow: boolean = false;
  private isDragged: boolean = false;
  private isExtended: boolean = false;
  private isEventClicked: boolean = false;

  private draggedEventNewStart?: Date;
  private draggedEventNewEnd?: Date;

  private coverEventTopPosition: number = 0;
  private coverEventBottomPosition: number = 0;
  private coverEventHeight: number = 0;
  private coverEventWidth: number = 0;
  private coverEventLeftPosition: number = 0;
  private isCoverEventShowing: boolean = false;
  private coverEventAssignedMember: string = '担当未設定';

  private coverEventTemporaryYPosition?: number;

  public colors: Array<string> = [
    'blue',
    'indigo',
    'deep-purple',
    'cyan',
    'green',
    'orange',
    'grey darken-1',
  ];
  public names: Array<string> = [
    'Meeting',
    'Holiday',
    'PTO',
    'Travel',
    'Event',
    'Birthday',
    'Conference',
    'Party',
  ];

  private isMenuPositionLeft: boolean = true;
  private isMenuPositionRight: boolean = false;

  private calendarAreaHeight: number = 200;

  get events() {
    return shiftDataStore.eventsForCalendar;
  }

  private calcCalendarAreaHeight() {
    const windowHeight = window.innerHeight;
    const commonHeaderHeight = 55;
    const shiftHeaderHeight = 64;
    this.calendarAreaHeight =
      windowHeight - commonHeaderHeight - shiftHeaderHeight - 100;
  }

  private weekdayFormat(event: any) {
    const weekdayChar = ['日', '月', '火', '水', '木', '金', '土'];
    return weekdayChar[event.weekday];
  }

  private intervalFormat(event: any) {
    return `${`  ${event.hour}`.slice(-2)}:${`00${event.minute}`.slice(-2)}`;
  }

  @Prop({ type: Function, required: true })
  public gotoCertainDate!: ({ date }: { date: string }) => void;

  @Prop({ type: Function, required: true })
  public updateTitle!: () => void;

  @Ref() calendar!: any;

  dragEvent: any = null;
  dragStart: any = null;
  dragTime: any = null;
  createEvent: any = null;
  createStart: any = null;
  extendOriginal: any = null;
  public mounted() {
    (this.$refs.calendar as any).checkChange();
    this.calcCalendarAreaHeight();
    window.addEventListener('resize', this.calcCalendarAreaHeight);
  }
  public beforeDestroy() {
    window.removeEventListener('resize', this.calcCalendarAreaHeight);
  }
  public getEventColor(event: any) {
    //return event.color;
    return '#359cf3'
  }
  public setToday() {
    this.focus = '';
  }
  public prev() {
    (this.$refs.calendar as any).prev();
  }
  public next() {
    (this.$refs.calendar as any).next();
  }
  public checkChange() {
    (this.$refs.calendar as any).checkChange();
  }
  public get calendarTitle() {
    if (!this.$refs.calendar) return '';

    const calendar = this.$refs.calendar as any;
    if (calendar.lastStart.year !== calendar.lastEnd.year) {
      return `${calendar.lastStart.year}年 ${calendar.lastStart.month}月 〜 ${calendar.lastEnd.year}年 ${calendar.lastEnd.month}月`;
    } else if (calendar.lastStart.month !== calendar.lastEnd.month) {
      return `${calendar.lastStart.year}年 ${calendar.lastStart.month}月 〜 ${calendar.lastEnd.month}月`;
    } else {
      return `${calendar.lastStart.year}年 ${calendar.lastStart.month}月`;
    }
  }
  public showShiftMenu(eventId: string, element?: Element) {
    // console.log(target)
    const open = () => {
      const shiftData = shiftDataStore.getSingleEventForCalendar(eventId);
      this.selectedElement = shiftData.weeklyDom;
      this.selectedEventId = eventId;
      const rect = shiftData.weeklyDom.getBoundingClientRect();
      const spaceWidth = rect.left + window.pageXOffset;
      if (spaceWidth < 400) {
        this.isMenuPositionLeft = false;
        this.isMenuPositionRight = true;
      } else {
        this.isMenuPositionLeft = true;
        this.isMenuPositionRight = false;
      }
      setTimeout(() => {
        this.selectedOpen = true;
      }, 10);
    };
    if (this.selectedOpen) {
      this.hideShiftMenu();
      setTimeout(open, 10);
    } else {
      open();
    }
  }
  public hideShiftMenu(isDeleteCreatedShift: boolean = false) {
    this.selectedOpen = false;
    this.selectedElement = undefined;
    if (this.createdEventId && isDeleteCreatedShift) {
      shiftDataStore.deleteShift(this.createdEventId);
    }
    this.createdEventId = undefined;
    this.selectedEventId = undefined;
  }
  public updateRange({ start, end }: { start: any; end: any }) {
    // 表示月や表示範囲が変わった際に発火されるイベントの実実装部分。現時点では必要ではないため空の関数。
  }

  toTime(tms: any) {
    return new Date(
      tms.year,
      tms.month - 1,
      tms.day,
      tms.hour,
      tms.minute
    ).getTime();
  }
  roundTime(time: any, down: boolean = true) {
    const roundTo = this.roundTo; // minutes
    const roundDownTime = roundTo * 60 * 1000;

    return down
      ? time - (time % roundDownTime)
      : time + (roundDownTime - (time % roundDownTime));
  }
  startDrag({
    event,
    timed,
    nativeEvent,
  }: {
    event: any;
    timed: boolean;
    nativeEvent: any;
  }) {
    if (this.selectedOpen && this.selectedEventId !== event.eventId) {
      this.isEventClicked = true;
      this.selectedEventId = event.eventId;
      // this.showShiftMenu(event.eventId);
      return;
    } else if (this.selectedOpen) {
      return;
    }
    const parentRect = nativeEvent.srcElement.parentElement.getBoundingClientRect();
    const eventRect = nativeEvent.srcElement.getBoundingClientRect();
    if (event) {
      this.dragEvent = event;
      this.dragTime = null;
      this.extendOriginal = null;
      this.coverEventTemporaryYPosition = this.calendar.timeToY({
        hour: event.start.getHours(),
        minute: event.start.getMinutes(),
      });
    }
  }
  async startTime(times: any) {
    if (this.selectedOpen) {
      return;
    }
    const mouse = this.toTime(times);
    this.isMouseDownNow = true;
    if (this.dragEvent && this.dragTime === null) {
      const start = this.dragEvent.start.getTime();

      this.dragTime = mouse - start;
    } else {
      this.createStart = new Date(this.roundTime(mouse));

      const newEventId = await shiftDataStore.addShiftAction({
        start: this.createStart,
        end: this.createStart,
      });
      this.createEvent = shiftDataStore.getSingleEventForCalendar(newEventId);
    }
  }
  extendBottom(event: any) {
    this.isMouseDownNow = true;
    this.createEvent = event;
    this.createStart = event.start;
    this.extendOriginal = event.end;
    this.isExtended = true;
  }
  mouseMove(times: any) {
    if (this.selectedOpen) {
      return;
    }
    if (this.isMouseDownNow) {
      this.isDragged = true;
    }
    const mouse = this.toTime(times);
    if (this.dragEvent && this.dragTime !== null) {
      const start = this.dragEvent.start.getTime();
      const end = this.dragEvent.end.getTime();
      const duration = end - start;
      const newStartTime = mouse - this.dragTime;
      const newStart = this.roundTime(newStartTime);
      const newEnd = newStart + duration;

      // console.log(this.dragEvent.weeklyDom.parentElement.parentElement);

      this.draggedEventNewStart = new Date(newStart);
      this.draggedEventNewEnd = new Date(newEnd);

      const topPosition =
        !(
          this.draggedEventNewStart.getFullYear() ===
            this.draggedEventNewEnd.getFullYear() &&
          this.draggedEventNewStart.getMonth() ===
            this.draggedEventNewEnd.getMonth() &&
          this.draggedEventNewStart.getDate() ===
            this.draggedEventNewEnd.getDate()
        ) &&
        Math.floor(
          (this.draggedEventNewStart.getTime() -
            this.draggedEventNewStart.getTimezoneOffset() * 60000) /
            86400000
        ) <
          Math.floor(
            (this.dragEvent.start.getTime() -
              this.dragEvent.start.getTimezoneOffset() * 60000) /
              86400000
          )
          ? this.calendar.timeToY({
              hour: 0,
              minute: 0,
            })
          : this.calendar.timeToY({
              hour: this.draggedEventNewStart.getHours(),
              minute: this.draggedEventNewStart.getMinutes(),
            });
      const bottomPosition =
        !(
          this.draggedEventNewStart.getFullYear() ===
            this.draggedEventNewEnd.getFullYear() &&
          this.draggedEventNewStart.getMonth() ===
            this.draggedEventNewEnd.getMonth() &&
          this.draggedEventNewStart.getDate() ===
            this.draggedEventNewEnd.getDate()
        ) &&
        Math.floor(
          (this.draggedEventNewEnd.getTime() -
            this.draggedEventNewEnd.getTimezoneOffset() * 60000) /
            86400000
        ) >
          Math.floor(
            (this.dragEvent.end.getTime() -
              this.dragEvent.end.getTimezoneOffset() * 60000) /
              86400000
          )
          ? this.calendar.timeToY({
              hour: 23,
              minute: 45,
            })
          : this.calendar.timeToY({
              hour: this.draggedEventNewEnd.getHours(),
              minute: this.draggedEventNewEnd.getMinutes(),
            });

      this.coverEventHeight = bottomPosition - topPosition;

      if (!this.coverEventTemporaryYPosition) {
        this.coverEventTemporaryYPosition = topPosition;
      }

      const yPoisitionDiff = topPosition - this.coverEventTemporaryYPosition!;

      const eventRect = this.dragEvent.weeklyDom.parentElement.getBoundingClientRect();

      const dayColumnRect = this.dragEvent.weeklyDom.parentElement.parentElement.parentElement.getBoundingClientRect();
      this.coverEventWidth = dayColumnRect.right - dayColumnRect.left;
      this.coverEventLeftPosition = dayColumnRect.left;
      if (
        this.draggedEventNewStart.getFullYear() ===
          this.draggedEventNewEnd.getFullYear() &&
        this.draggedEventNewStart.getMonth() ===
          this.draggedEventNewEnd.getMonth() &&
        this.draggedEventNewStart.getDate() ===
          this.draggedEventNewEnd.getDate() &&
        Math.floor(
          (this.draggedEventNewStart.getTime() -
            this.draggedEventNewStart.getTimezoneOffset() * 60000) /
            86400000
        ) !==
          Math.floor(
            (this.dragEvent.start.getTime() -
              this.dragEvent.start.getTimezoneOffset() * 60000) /
              86400000
          )
      ) {
        const diffDays =
          Math.floor(
            (this.draggedEventNewStart.getTime() -
              this.draggedEventNewStart.getTimezoneOffset() * 60000) /
              86400000
          ) -
          Math.floor(
            (this.dragEvent.start.getTime() -
              this.dragEvent.start.getTimezoneOffset() * 60000) /
              86400000
          );
        this.coverEventLeftPosition += diffDays * this.coverEventWidth;
      }

      this.coverEventTopPosition = eventRect.top + yPoisitionDiff;
      this.coverEventBottomPosition =
        this.coverEventHeight + this.coverEventTopPosition;

      this.isCoverEventShowing = true;

      this.coverEventAssignedMember = this.dragEvent.name;

      const parentElement = document.querySelector(
        `[data-event-id="${this.dragEvent.eventId}"]`
      )?.parentElement;
      if (parentElement) {
        parentElement.style.opacity = '50%';
      }
    } else if (this.createEvent && this.createStart !== null) {
      const mouseRounded = this.roundTime(mouse, false);
      const dayFixedDate = new Date(mouseRounded);
      dayFixedDate.setFullYear(this.createStart.getFullYear());
      dayFixedDate.setMonth(this.createStart.getMonth());
      dayFixedDate.setDate(this.createStart.getDate());
      const min = this.createStart.getTime();
      const max = Math.max(
        dayFixedDate.getTime(),
        this.createStart.getTime() + this.roundTo * 60000
      );

      this.draggedEventNewStart = new Date(min);
      this.draggedEventNewEnd = new Date(max);

      const topPosition = this.calendar.timeToY({
        hour: this.draggedEventNewStart.getHours(),
        minute: this.draggedEventNewStart.getMinutes(),
      });
      const bottomPosition = this.calendar.timeToY({
        hour: this.draggedEventNewEnd.getHours(),
        minute: this.draggedEventNewEnd.getMinutes(),
      });
      this.coverEventHeight = bottomPosition - topPosition;

      const dayColumnRect = this.createEvent.weeklyDom.parentElement.parentElement.parentElement.getBoundingClientRect();
      this.coverEventWidth = dayColumnRect.right - dayColumnRect.left;
      this.coverEventLeftPosition = dayColumnRect.left;

      const eventRect = this.createEvent.weeklyDom.parentElement.getBoundingClientRect();
      this.coverEventTopPosition = eventRect.top;
      this.coverEventBottomPosition =
        this.coverEventHeight + this.coverEventTopPosition;

      this.isCoverEventShowing = true;

      this.coverEventAssignedMember = this.createEvent.name;

      const parentElement = document.querySelector(
        `[data-event-id="${this.createEvent.eventId}"]`
      )?.parentElement;
      if (parentElement) {
        parentElement.style.opacity = '50%';
      }

      shiftDataStore.updateEvent({
        eventId: this.createEvent.eventId,
        temporary: true,
      });
    }
  }
  endDrag(times: any) {
    if (this.selectedOpen && this.isEventClicked) {
      this.isEventClicked = false;
      this.showShiftMenu(this.selectedEventId!);
      return;
    } else if (this.selectedOpen) {
      return;
    }
    if (!this.isDragged && !this.isExtended && !this.createEvent) {
      this.showShiftMenu(this.dragEvent.eventId);
    } else if (!this.isDragged && this.createEvent && !this.isExtended) {
      this.showShiftMenu(this.createEvent.eventId);
    } else if (this.isDragged && !this.isExtended && !this.createEvent) {
      shiftDataStore.updateEvent({
        eventId: this.dragEvent.eventId,
        start: this.draggedEventNewStart,
        end: this.draggedEventNewEnd,
        temporary: false,
      });
      const parentElement = document.querySelector(
        `[data-event-id="${this.dragEvent.eventId}"]`
      )?.parentElement;
      if (parentElement) {
        parentElement.style.opacity = '100%';
      }
    } else if (this.isDragged && this.createEvent && this.isExtended) {
      shiftDataStore.updateEvent({
        eventId: this.createEvent.eventId,
        start: this.draggedEventNewStart,
        end: this.draggedEventNewEnd,
        temporary: false,
      });
      const parentElement = document.querySelector(
        `[data-event-id="${this.createEvent.eventId}"]`
      )?.parentElement;
      if (parentElement) {
        parentElement.style.opacity = '100%';
      }
    } else if (this.isDragged && this.createEvent && !this.isExtended) {
      shiftDataStore.updateEvent({
        eventId: this.createEvent.eventId,
        start: this.draggedEventNewStart,
        end: this.draggedEventNewEnd,
        temporary: false,
      });
      const parentElement = document.querySelector(
        `[data-event-id="${this.createEvent.eventId}"]`
      )?.parentElement;
      if (parentElement) {
        parentElement.style.opacity = '100%';
      }
      this.showShiftMenu(this.createEvent.eventId);
    }
    if (this.createEvent && !this.isExtended) {
      this.createdEventId = this.createEvent.eventId;
    }
    this.dragTime = null;
    this.dragEvent = null;
    this.createEvent = null;
    this.createStart = null;
    this.extendOriginal = null;
    this.isMouseDownNow = false;
    this.isDragged = false;
    this.isExtended = false;
    delete this.draggedEventNewEnd;
    delete this.draggedEventNewStart;
    this.isCoverEventShowing = false;
    delete this.coverEventTemporaryYPosition;
  }
  cancelDrag(e: any) {
    if (this.createEvent) {
      const parentElement = document.querySelector(
        `[data-event-id="${this.createEvent.eventId}"]`
      )?.parentElement;
      if (parentElement) {
        parentElement.style.opacity = '100%';
      }
    }
    if (this.dragEvent) {
      const parentElement = document.querySelector(
        `[data-event-id="${this.dragEvent.eventId}"]`
      )?.parentElement;
      if (parentElement) {
        parentElement.style.opacity = '100%';
      }
    }

    this.createEvent = null;
    this.createStart = null;
    this.dragTime = null;
    this.dragEvent = null;
    this.extendOriginal = null;
    this.isMouseDownNow = false;
    this.isDragged = false;
    this.isExtended = false;
    delete this.draggedEventNewEnd;
    delete this.draggedEventNewStart;
    this.isCoverEventShowing = false;
    delete this.coverEventTemporaryYPosition;
  }
  public clickOnOutsideOfPopup(e: boolean) {
    if (!e) {
      this.hideShiftMenu(true);
    }
  }
  public changeActivator() {
    const targetEvent = shiftDataStore.getSingleEventForCalendar(
      this.selectedEventId!
    );
    const lastStart = this.calendar.lastStart;
    const lastStartDate = new Date(
      lastStart.year,
      lastStart.month - 1,
      lastStart.day
    );
    const eventStartDate = new Date(
      targetEvent.start.getFullYear(),
      targetEvent.start.getMonth(),
      targetEvent.start.getDate()
    );
    const pageDiffCount = Math.floor(
      (eventStartDate.getTime() - lastStartDate.getTime()) / (86400000 * 7)
    );
    this.calendar.move(pageDiffCount);
    this.showShiftMenu(this.selectedEventId!);
  }
  public scrollToTime(
    time: number | string | { hour: number; minute: number }
  ) {
    this.calendar.scrollToTime(time);
  }
}
